'use client';

import { useFormContext } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import { Input, IInputProps } from '@/components/ui/Input';

type Props = {
  name: string;
  label?: string;
  description?: string;
  rootClassName?: string;
} & IInputProps;

const TextField = ({
  name, label, description, rootClassName, ...inputProps
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={rootClassName}>
          {label && (
            <FormLabel>
              {label} {inputProps.required && '*'}
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...inputProps}
              {...field}
              error={!!errors[name]?.message}
              placeholder={
                inputProps.placeholder && inputProps.required && !label
                  ? `${inputProps.placeholder} *`
                  : inputProps.placeholder
              }
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TextField;
